import React, { useContext } from 'react';
import { TreeItem } from '@material-ui/lab';
import { isAdministrator, UserContext } from '../../../context/user';
import { SalesAgencyRow } from '../SalesAgencyRow/SalesAgencyRow';

export function TreeLeaf({ agency, showActions, nodeId, matchedItemIds = [] }) {
  const user = useContext(UserContext);

  return (
    <TreeItem
      nodeId={nodeId}
      label={
        <SalesAgencyRow
          highlighted={matchedItemIds.includes(nodeId)}
          agency={agency.user}
          showEditIcon={showActions}
          showEmailIcon={showActions}
        />
      }
    >
      {agency.children.length !== 0 ? agency.children.map(child => (
        <TreeLeaf
          key={child.user.ID}
          agency={child}
          nodeId={child.user.ID.toString()}
          showActions={isAdministrator(user)}
          matchedItemIds={matchedItemIds}
        />
      )) : null}
    </TreeItem>
  )
}
